import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import api from './api';
import { installAuthInterceptor } from './auth';
import './assets/tailwind.css';

// Odmítnutý token administrace (401/403) → přihlášení s návratem, ne prázdný dashboard.
installAuthInterceptor(api, router);

createApp(App).use(router).mount('#app');
